export const HISTORY_LIMIT = 100;
